const state = {
     end_information :'',
     educationList:[],
     jobList:[],
     sundryList:[]
};

const mutations = {
     set_end_information(state,val){
         state.end_information = val;
     },
    set_educationList(state,val){
         state.educationList =val
    },
    set_jobList(state,val){
         state.jobList =val
    },
    set_sundryList(state,val){
         state.sundryList =val
    },


};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
